import { getFitAndReliabilityScores } from '../../Reducers/filterReducer';
import {  newTeeTypesObjectEmptyOrZero, teeMeasuresAveragesObjectEmptyOrZero } from '../../tools/generalProperties';
import { CssColorValues } from '../../types/databaseTables/generaldata';
import { AllTShirtMeasuresMandatory } from '../../types/databaseTables/idealteemeasures';
import { NewTeeTypesRow } from '../../types/databaseTables/newteetypes';
import { TeeMeasuresAveragesRow } from '../../types/databaseTables/teemeasuresaverages';
import { VendorsRow } from '../../types/databaseTables/vendors';
import { GarmentObjectGarmentPage } from '../../types/reducers/filterReducer';

export const emptyGarmentObject: GarmentObjectGarmentPage = {
    ...teeMeasuresAveragesObjectEmptyOrZero,
    ...newTeeTypesObjectEmptyOrZero,
    fit: 0,
    reliability: 0,
    vendorsWebsite: "",
};

export type MatchingColorsObj = Record<string, Array<CssColorValues>>;

export function getArrayOfAvailableSizes(
    teeMeasuresArray: TeeMeasuresAveragesRow[],
    newTeeTypesId: number
): string[] {
    return teeMeasuresArray
        .filter((thisItem) => thisItem.newteetypes_id === newTeeTypesId)
        .map((x) => x.size.toLowerCase())
        .filter((thisItem, index, originalArray) => originalArray.indexOf(thisItem) === index);
}

export function getThisVendorWebsite(
    manufacturer: string,
    vendorsState: VendorsRow[]
): string | undefined {
    return vendorsState.find((vendorRow) => vendorRow.vendorname === manufacturer)?.website;
}


export function createGarmentObjectFromId(
    pageTeeTypeId: number,
    newTeeTypesRows: NewTeeTypesRow[],
    teeMeasuresAveragesRows: TeeMeasuresAveragesRow[],
    vendors: VendorsRow[],
    userFitScoreWeights: AllTShirtMeasuresMandatory,
    idealGarmentMeasurements: AllTShirtMeasuresMandatory,
): GarmentObjectGarmentPage {
    const thisTeeTypeObject = newTeeTypesRows.find(
        (thisRow) => thisRow.newteetypes_id === pageTeeTypeId
    );
    const thisTeeMeasureAveragesObject = teeMeasuresAveragesRows.find(
        (thisRow) => thisRow.newteetypes_id === pageTeeTypeId
    );
    if (thisTeeMeasureAveragesObject === undefined || thisTeeTypeObject === undefined) {
        return emptyGarmentObject;
    }
    const vendorsWebsite = getThisVendorWebsite(
        thisTeeTypeObject.manufacturer,
        vendors
    ) || "";

    const fitAndReliabiltyScore = getFitAndReliabilityScores(
        thisTeeMeasureAveragesObject,
        userFitScoreWeights,
        idealGarmentMeasurements
    )
    return { ...thisTeeMeasureAveragesObject, ...thisTeeTypeObject, ...fitAndReliabiltyScore, vendorsWebsite };
}

